import { QuoteEmail } from "./email.model";

export class QuoteEmailMapper {
  public static map(data: any): QuoteEmail {
    if (!data) {
      return null;
    }

    return new QuoteEmail(
      data.to,
      data.cc,
      data.bcc,
      data.subject,
      data.message ? data.message : "",
      data.attachments,
      data.messageId ?? null,
      data.receivedAt ?? null,
    );
  }
}
